import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isEmpty } from 'lodash';
import { combineLatest, map, Observable } from 'rxjs';
import { ObjectWith } from '../../../../../../../cross-team-shared/types/misc';
import { ShapeFeedback } from '../../../../../../../team-apis/otterdam/feedback';
import { TaskWorkspaceStore } from '../../../../../../h3ml/state/task-workspace-store';
import {
  FeedbackDisplayItem,
  FeedbackListComponent,
} from './feedback-list.component';

const icons: ObjectWith<string> = {
  'Missing Shape': 'missingShapeFeedback',
  'Extra Shape': 'extraShapeFeedback',
  'Inaccurate Shape': 'inaccurateShapeFeedback',
  'Incorrect Attribute': 'incorrectAttributeFeedback',
  'Incorrect Label': 'incorrectLabelFeedback',
};

@Component({
  selector: 'h3-shape-feedback-list',
  templateUrl: './shape-feedback-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeedbackListComponent, AsyncPipe],
})
export class ShapeFeedbackListComponent {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  feedback$ = this.buildFeedback$();

  private buildFeedback$(): Observable<FeedbackDisplayItem[]> {
    return combineLatest([
      this.taskWorkspaceStore('shapeFeedback').$,
      this.taskWorkspaceStore('feedbackPopover')('shapeFilterIds').$,
    ]).pipe(
      map(([shapeFeedbackList, shapeFilterIds]) => {
        const filteredFeedbackList = shapeFeedbackList.filter(
          (shapeFeedback) =>
            isEmpty(shapeFilterIds) ||
            (shapeFeedback.shapeId &&
              shapeFilterIds.includes(shapeFeedback.shapeId)),
        );

        const sortedList = filteredFeedbackList.sort(
          (a, b) =>
            new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf(),
        );

        return sortedList.map((feedback) => this.buildItem(feedback));
      }),
    );
  }

  private buildItem(feedback: ShapeFeedback): FeedbackDisplayItem {
    return {
      id: feedback.feedbackId,
      outputId: feedback.outputId,
      errorType: feedback.errorTag,
      title: feedback.errorTag,
      comment: feedback.comment,
      shapeId: feedback.shapeId,
      startFrame: feedback.startFrame || 0,
      endFrame: feedback.endFrame,
      coordinates: feedback.coordinates,
      updatedAt: feedback.updatedAt,
      iconName: icons[feedback.errorTag],
    };
  }
}
